import { styled } from '@mui/material/styles';
import { func, object, oneOfType, string } from 'prop-types';
import React from 'react';

const HiddenFileInput = styled('input')({
  position: 'absolute',
  top: 0,
  opacity: 0,
});

const acceptDefault = `
    image/jpeg,
    image/jpg,
    image/png,
    image/gif,
    audio/mp3,
    audio/mpeg,
    audio/aac,
    audio/ogg,
    audio/m4a,
    video/mp4,
    video/quicktime,
    video/avi,
    video/mpeg,
    application/pdf,
    application/msword,
    application/vnd.ms-excel,
    application/vnd.ms-powerpoint,
    application/vnd.openxmlformats-officedocument.wordprocessingml.document,
    application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,
    application/vnd.openxmlformats-officedocument.presentationml.presentation,
    application/wps-office.docx
  `.replace(/\s/g, '');

const FileInput = ({ onChange, inputRef, accept = acceptDefault, ...rest }) => {
  return (
    <HiddenFileInput type="file" ref={inputRef} onChange={onChange} accept={accept} {...rest} />
  );
};

FileInput.propTypes = {
  inputRef: oneOfType([func, object]).isRequired,
  onChange: func.isRequired,
  accept: string,
};

export default FileInput;
